module.exports = __webpack_public_path__ + "static/img/作品93.ddb6bdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品93.png
// module id = 4Gsg
// module chunks = 1